export const VENUE_MAP_MARKETPLACES_CONFIGURATION = {
  ticketnetwork: {
    y: 0,
    x: 0,
    width: 4096,
    height: 4096,
  },
  seatgeek: {
    y: -140,
    x: -90,
    width: 2230,
    height: 2280,
  },
};

export const DEFAULT_MARKETPLACE = 'seatgeek';

export const MARKETPLACES_TABS = {
  ticketnetwork: 0,
  seatgeek: 1,
};

export const MARKETPLACE_LABELS = {
  ticketnetwork: 'TicketNetwork',
  seatgeek: 'SeatGeek',
};

export const MARKETPLACE_ITEMS = [
  {
    label: 'SeatGeek',
    value: 'seatgeek',
    id: 1,
  },
  {
    label: 'TicketNetwork',
    value: 'ticketnetwork',
    id: 0,
  },
];

export const ORG_TABLEAU_DASHBOARDS = {
  32: [
    {
      label: 'Sales Curve',
      url:
        'https://prod-useast-b.online.tableau.com/t/repscoanalytics/views/KillshotTableauRUBS/SalesCurve/ed2fa3a4-54be-4aa6-bb89-338d3fe5e2f8/47b0b535-7f24-41e1-a2c6-6b40dee004aa?:toolbar=no&:embed=true',
      id: 1,
      default: true,
    },
  ],
  1: [
    {
      label: 'Sales Curve',
      url:
        'https://prod-useast-b.online.tableau.com/t/repscoanalytics/views/KillshotTableauRUBS/SalesCurve/ed2fa3a4-54be-4aa6-bb89-338d3fe5e2f8/47b0b535-7f24-41e1-a2c6-6b40dee004aa?:toolbar=no&:embed=true',
      id: 1,
      default: true,
    },
  ],
  31: [
    {
      label: 'Sales Curve',
      url: 'https://prod-useast-b.online.tableau.com/t/repscoanalytics/views/KillshotTableauUPBEAT/SalesCurve',
      id: 1,
      default: true,
    },
  ],
  33: [
    {
      label: 'Sales Curve',
      url: 'https://prod-useast-b.online.tableau.com/#/site/repscoanalytics/views/KillshotTableauMJSEATS/SalesCurve',
      id: 1,
      default: true,
    },
  ],
};

const PRIME_BROKERAGE_ORG = 32;
const REPS_CO_ORG = 1;
export const UPBEAT_ORG = 31;
const MJ_SEATS_ORG = 33;
const RUBS_SPECS_ORG = 43;

export const EVENT_TOUR_ORG = [PRIME_BROKERAGE_ORG, REPS_CO_ORG, UPBEAT_ORG, MJ_SEATS_ORG];
export const MY_EVENTS_ORG = [PRIME_BROKERAGE_ORG, REPS_CO_ORG];
export const EVENT_TOUR_PRICING = 'pricing';
export const EVENT_TOUR_MARKET = 'market';
export const AB_TEST_ORG = [PRIME_BROKERAGE_ORG];
export const DAILY_PULSE_ORG = [PRIME_BROKERAGE_ORG];

export const GROUP_CRITERIA_SPLITS = [
  {
    value: 'All',
    label: 'All',
  },
  {
    value: 1,
    label: '1',
  },
  {
    value: 2,
    label: '2',
  },
  {
    value: 3,
    label: '3',
  },
  {
    value: 4,
    label: '4',
  },
  {
    value: 5,
    label: '5',
  },
  {
    value: 6,
    label: '6',
  },
  {
    value: 7,
    label: '7',
  },
  {
    value: 8,
    label: '8',
  },
];

// Properties changes that enables push to sb button
export const PUSH_TO_SB_ENABLE = [
  'marketplace',
  'floor',
  'ceiling',
  'manual_price',
  'increment_symbol',
  'increment',
  'increment_type',
  'spaceout',
  'spaceout_type',
  'auto_broadcast',
  'splits',
  'advanceSettings',
  'comp_all',
  'comps',
  'ranks',
  'discount',
  'sg_discount',
  'exclude_obstructed_view',
  'inclusions_exclusions',
  'custom_split',
  'split_type',
  'sg_sections',
  'tnd_sections',
  'dynamic_spaceout_enabled',
];

// Properties changes that enables orange dot on save button per group
export const SAVE_ENABLE = [
  'discount',
  'sg_discount',
  'exclude_obstructed_view',
  'inclusions_exclusions',
  'custom_split',
  'split_type',
  'advanceComparison',
];

export const TARGET_HELD_ACCESS = [PRIME_BROKERAGE_ORG, REPS_CO_ORG, UPBEAT_ORG];
export const SS_FILTER_ACCESS = [PRIME_BROKERAGE_ORG, REPS_CO_ORG];
export const SS_FILTER_ORGANIZATIONS = [
  {
    id: 32,
    label: 'REPS Prime Brokerage',
  },
  {
    id: 1,
    label: 'REPS & Co.',
  },
  {
    id: 33,
    label: 'MJ Seats',
  },
];

export const FIELDS_TAKE_SERVER_VALUE = ['last_date_change', 'last_user_change', 'last_api_change'];
export const ORGANIZATIONS = {
  '32': 'REPS Prime Brokerage',
  '1': 'REPS & Co.',
  '33': 'MJ Seats',
};

export const SS_ORGS_WITHOUT_COTA_AT_FLOOR_ACCESS = [RUBS_SPECS_ORG];

export const ORGS_WITH_AUTOMATION_TAB_ACCESS = [PRIME_BROKERAGE_ORG, REPS_CO_ORG];

export const ORGS_WITH_DYNAMIC_SPACE_ACCESS = [PRIME_BROKERAGE_ORG, REPS_CO_ORG];

export const ORGS_WITH_PRICING_NOTES_ACCESS = [PRIME_BROKERAGE_ORG, REPS_CO_ORG];

export const DEFAULT_AUTOMATION_STRATEGY = 'Needs Manual Assignment';

export const LINE_SEGMENT_SPIDER = 'Line Segment - SPIDER';

export const AUTOMATION_STRATEGIES = {
  SPIDER: {
    key: 'SPIDER',
    label: 'SPIDER',
  },
  KOBE: {
    key: 'KOBE',
    label: 'KOBE',
  },
  KOBE_ZONE: {
    key: 'KOBE_ZONE',
    label: 'ZONE KOBE',
  },
};

export const AUTOMATION_SPIDER_EXCLUSIONS = [
  'All Spider',
  'Positive Divergence SPIDER only',
  'All Lowers (Negative Divergence & Stall)',
  'Negative Divergence Spider Only',
  'Stall only',
  'Postive Divergence & Stall',
  'Remove from Spooder',
];

export const REMOVE_FROM_SPOODER_VALUE = 'Remove from Spooder';

// Generate all valid spider_exclusion values: individual exclusions + combinations with "Remove from Spooder"
const EXCLUSION_TYPES_WITHOUT_SPOODER = AUTOMATION_SPIDER_EXCLUSIONS.filter(e => e !== REMOVE_FROM_SPOODER_VALUE);
export const VALID_SPIDER_EXCLUSION_VALUES = [
  ...AUTOMATION_SPIDER_EXCLUSIONS,
  ...EXCLUSION_TYPES_WITHOUT_SPOODER.map(e => `${e},${REMOVE_FROM_SPOODER_VALUE}`),
];

export const SEGMENT_EXPECTATIONS = {
  sport_event: {
    lse_dte_30: 'DTE 30 Target',
    lse_dte_15: 'DTE 15 Target',
    lse_dte_4: 'DTE 4 Target',
    lse_sellout_dte_target: 'S/O DTE Target',
    lse_sellout_dte: 'Sellout DTE',
  },
  non_sport_event: {
    lse_dte_60: 'DTE 60 Target',
    lse_dte_30: 'DTE 30 Target',
    lse_dte_7: 'DTE 7 Target',
    lse_sellout_dte_target: 'S/O DTE Target',
    lse_sellout_dte: 'Sellout DTE',
  },
};

export const LOCALE = 'en-US';
const uniquePricingOrgEnabled = process.env.UNIQUE_PRICING_ORG_ENABLED || '';
export const MARKETPLACE_UNIQUE_ORGS_ACCESS = uniquePricingOrgEnabled.split(',').map(Number);

export const BROADCASTING_STRATEGY_OPTIONS = {
  StubHub: {
    ignorePhrase: '-STUB',
    includePhrase: '+stub',
  },
  TicketNetwork: {
    ignorePhrase: '-TND',
    includePhrase: '+tnet',
  },
  'TM+': {
    ignorePhrase: '-TNOW',
    includePhrase: '+tmplus',
  },

  Vivid: {
    ignorePhrase: '-VIVID',
    includePhrase: '+vivid',
  },

  TicketEvolution: {
    ignorePhrase: '-TEVO',
    includePhrase: '+tevo',
  },

  Viagogo: {
    ignorePhrase: '-GOGO',
    includePhrase: '+gogo',
  },

  FanXchange: {
    ignorePhrase: '-fanx',
    includePhrase: '+fanx',
  },

  TickPick: {
    ignorePhrase: '-TPICK',
    includePhrase: '+pick',
  },

  TicketMonster: {
    ignorePhrase: '-MONSTER',
    includePhrase: '+monster',
  },

  Gametime: {
    ignorePhrase: '-GTIME',
    includePhrase: '+game',
  },

  SeatGeek: {
    ignorePhrase: '-GEEK',
    includePhrase: '+geek',
  },

  'Automatiq B2B': {
    ignorePhrase: '-auto',
    includePhrase: '+auto',
  },

  AXS: {
    ignorePhrase: '-AXS',
    includePhrase: '+AXS',
  },

  GoTickets: {
    ignorePhrase: '-gotick',
    includePhrase: '+gotick',
  },
};

export const AUDIT_REQUEST_SIZE = 20000;

export const NOTES_PANEL = {
  NOTES: 'NOTES',
  PRICING: 'PRICING',
  GENERAL: 'GENERAL',
};

export const PRICING_NOTES_CURRENT_PERIOD = [
  'Onsale',
  'Post Onsale',
  'Lull',
  '60 DTE',
  '45 DTE',
  '30 DTE',
  '7 DTE',
  'Sellout Date/Event Day',
];

export const PRICING_NOTES_ACTION_STRATEGIES = ['Cut', 'Raise', 'Retain Prices'];

export const PRICING_NOTES_DROPS_CUTS = [
  'Dropped Tickets',
  'Cut Prices',
  'Dropped Tickets and Cut Prices',
  'Price Increase',
  'None',
];

export const PRICING_NOTES_PRIMARY_QUANTITY_STATUS = {
  TICKETS_AVAILABLE: 'Tickets Available',
  SOLD_OUT: 'Sold Out',
};
